import React, { Component } from "react";
import '../css/albumorder.css'
import ReactModal from "react-modal";
import AlbumPhotoItem from "./AlbumPhotoItem";
class AlbumLineItemSummary extends Component {
  render() {
    const { album } = this.props;
    const { attributes } = album;
    
    // Function to detect cover photos based on URL patterns
    const isCoverPhoto = (photoUrl) => {
      const coverPatterns = [
        'cover-imposed',
        'cover_imposed',
        'coverphoto',
        'cover-photo',
        '/cover/',
        'cover.'
      ];

      return coverPatterns.some(pattern => photoUrl.includes(pattern));
    };

    // Sort photos 
    const getOrderInfo = (photoUrl) => {
      const isCover = isCoverPhoto(photoUrl);
      const name = (photoUrl || "").split("?")[0].split("/").pop() || "";
      // grab the LAST numeric group in the filename (most robust)
      const nums = name.match(/\d+/g);
      const seq = nums ? parseInt(nums[nums.length - 1], 10) : Number.POSITIVE_INFINITY;
    
      return { isCover, seq, name };
    };
    
    const sortedPhotos = attributes.album_photos
      ? [...attributes.album_photos].sort((a, b) => {
          const A = getOrderInfo(a.photo_url);
          const B = getOrderInfo(b.photo_url);
    
          // 1) Cover first
          if (A.isCover && !B.isCover) return -1;
          if (!A.isCover && B.isCover) return 1;
    
          // 2) Then by numeric sequence (ascending)
          if (A.seq !== B.seq) return A.seq - B.seq;
    
          // 3) Finally by filename (A–Z) for stability
          if (A.name < B.name) return -1;
          if (A.name > B.name) return 1;
          return 0;
        })
      : [];

    const photoCount = sortedPhotos.length;

    return (
      <div className="album-card">
        <div className="album-header">
          <h2 className="album-title">{attributes.description}</h2>
          <span className="text-block-69">Album ID: {album.id} • GUID: {attributes.guid}</span>
        </div>
        
        <div className="properties-grid">
          <div className="property-group">
            <div className="property-name">Description</div>
            <div className="property-item">
              <span className="property-value">{attributes.description}</span>
            </div>
          </div>
          
          <div className="property-group">
            <div className="property-name">Fabric</div>
            <div className="property-items-container">
              <div className="property-item">
                <span className="property-label">Outer Fabric:</span>
                <span className="property-value">{attributes.outer_fabric_name || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Inner Fabric:</span>
                <span className="property-value">{attributes.inner_fabric_name || "None"}</span>
              </div>
            </div>
          </div>
          
          <div className="property-group">
            <div className="property-name">Design</div>
            <div className="property-items-container">
              <div className="property-item">
                <span className="property-label">Font:</span>
                <span className="property-value">{attributes.font || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Spread Qty:</span>
                <span className="property-value">{attributes.spread_quantity || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Stamping:</span>
                <span className="property-value">
                  {attributes.stamping || 'None'}
                </span>
              </div>
            </div>
          </div>
        
          <div className="property-group item-1">
            <div className="property-name">Cover Text Properties</div>
            <div className="property-items-container">
              <div className="property-item">
                <span className="property-label">Upper Text Value:</span>
                <span
                  className="property-value"
                  style={{ color: attributes.upper_text_properties.upper_text_color || "None" }}
                >
                  {attributes.upper_text_properties.upper_text_value || "None"}
                </span>
              </div>
              <div className="property-item">
                <span className="property-label">Upper Text Font Size:</span>
                <span className="property-value">{`${attributes.upper_text_properties.upper_text_font_size}px` || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Lower Text Value:</span>
                <span className="property-value">{attributes.lower_text_properties.lower_text_value || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Lower Text Font Size:</span>
                <span className="property-value">{`${attributes.lower_text_properties.lower_text_font_size}px` || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Text Font:</span>
                <span className="property-value">{attributes.upper_text_properties.upper_text_font || "None"}</span>
              </div>
              <div className="property-item">
                <span className="property-label">Text Color:</span>
                <span className="property-value">
                  <span
                    className="color-swatch"
                    style={{ backgroundColor: attributes.upper_text_properties.upper_text_color || "None" }}></span>
                  {attributes.upper_text_properties.upper_text_color || "None"}
                </span>
              </div>
            </div>
          </div>

          <div className="property-group">
            <div className="property-name">Price</div>
            <div className="property-item">
              <span className="property-value">${Number(attributes.total_price).toFixed(2)}</span>
            </div>
          </div>
        </div>
    
        <div className="photos-section">
          <h3 className="photos-title">Album Photos ({photoCount})</h3>
          <div className="photos-scroll-container">
            <div className="photos-grid">
              {sortedPhotos.map((photo, index) => {
                const isCover = isCoverPhoto(photo.photo_url);
                return (
                  <AlbumPhotoItem
                    key={photo.photo_guid} 
                    photo={photo} 
                    index={index} 
                    isCover={isCover}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlbumLineItemSummary;
